import {
  createFileRoute,
  Outlet,
  useLocation,
  Link,
} from "@tanstack/react-router";

import MarketingFooter from "@/components/MarketingFooter";
import { MarketingNavBar } from "@/components/MarketingNavBar";
import { Separator } from "@/components/ui/separator";
import {
  Sidebar,
  SidebarContent,
  SidebarProvider,
  SidebarTrigger,
} from "@/components/ui/sidebar";
// @ts-expect-error Dunno how to do types
import illustration from "@/images/illustration.png?slice=1&height=500&y=3050";

export const Route = createFileRoute("/_marketplace-layout")({
  component: RouteComponent,
});

function RouteComponent() {
  const { pathname } = useLocation();

  return (
    <SidebarProvider>
      <div className="bg-teal-4 dark:bg-tealdark-4 flex flex-col text-teal-normal w-full relative">
        <header className="mx-auto w-screen px-6 md:px-10 xl:px-20 md:max-w-[calc(1216px+280px+280px)] py-4 flex flex-col gap-6 md:gap-8">
          <MarketingNavBar left={<SidebarTrigger static />} />
        </header>
        <div className="h-[30vh] md:h-[50vh]  overflow-hidden fixed inset-x-0 bottom-0">
          <img
            src={illustration as string}
            alt=""
            className="object-cover h-full w-full relative"
          />
          <div className="absolute inset-0 bg-linear-to-t from-[-60%] to-95% from-transparent to-teal-4 dark:to-tealdark-4"></div>
        </div>

        <div className="flex-1 min-h-0 grid md:max-w-[calc(1216px+280px)] md:grid-cols-[280px_1fr] 2xl:max-w-[calc(1216px+280px+280px)] 2xl:grid-cols-[280px_1fr_minmax(0,280px)] mx-auto w-screen px-6 md:px-10 xl:px-16">
          <div className="md:mt-12">
            <Sidebar variant="inset" className="w-full px-2">
              <SidebarContent>
                <nav className="flex flex-col gap-2">
                  <Link
                    className="uppercase underline p-2 text-2xl font-semibold hover:text-teal-11 underline-offset-6"
                    to="/marketplace"
                  >
                    Marketplace
                    {pathname.includes("/marketplace") && <span> ★</span>}
                  </Link>
                  <div className="pl-2 pr-16">
                    <Separator className="h-px bg-teal-8 dark:bg-tealdark-8 border-0 my-4" />
                  </div>
                  <Link
                    className="uppercase underline p-2 text-2xl font-semibold hover:text-teal-11 underline-offset-6"
                    to="/ads"
                  >
                    Ads
                    {pathname.includes("/ads") && <span> ★</span>}
                  </Link>
                  <Link
                    className="uppercase underline p-2 text-2xl font-semibold hover:text-teal-11 underline-offset-6"
                    to="/feeds"
                  >
                    Public Feeds
                    {pathname.includes("/feeds") && <span> ★</span>}
                  </Link>

                  <Link
                    className="uppercase underline p-2 text-2xl font-semibold hover:text-teal-11 underline-offset-6"
                    to="/custom-nodes"
                  >
                    Custom Nodes
                    {pathname.includes("/custom-nodes") && <span> ★</span>}
                  </Link>
                </nav>
              </SidebarContent>
            </Sidebar>
          </div>
          <main className="flex flex-col flex-1 min-w-0 relative">
            <Outlet />
          </main>
        </div>
        <MarketingFooter variant="slate" />
      </div>
    </SidebarProvider>
  );
}
